module.exports = __webpack_public_path__ + "static/media/education.3b3c1347.png";